export default IconMoon2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-moon-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M16.418 4.157a8 8 0 0 0 0 15.686" />
  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
</svg>`;